import { Box, Grid, IconButton, Paper } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import { Formik } from "formik";
import React from "react";
import { Link, useHistory } from "react-router-dom";

import { Center } from "../../../../components/center";
import { DateInput } from "../../../../components/date_input";
import { Routing } from "../../../../core/routing";
import { ROUTES } from "../../../../routes";
import {
  ISingleClientHistoryFilter,
  singleClientHistoryFilterToQueryParams,
  singleClientHistoryQueryParamsToFilter,
} from "../../data/filter";

interface IProps {
  clientId: string;
}

const todayDate = new Date();

export const SingleClientHistoryFilter: React.FC<IProps> = ({ clientId }: IProps) => {
  const history = useHistory();

  const initialFilter: ISingleClientHistoryFilter = {
    createdDateRange: {
      from: todayDate,
      to: todayDate,
    },
    clientId,
  };

  function onSubmit(values: ISingleClientHistoryFilter) {
    history.push({
      search: singleClientHistoryFilterToQueryParams(values),
    });
  }

  const initialValues = history.location.search
    ? singleClientHistoryQueryParamsToFilter(history.location.search, clientId)
    : initialFilter;

  return (
    <Box mt={3}>
      <Formik<ISingleClientHistoryFilter> initialValues={initialValues} onSubmit={onSubmit} enableReinitialize>
        {({ values, submitForm, setFieldValue }) => {
          return (
            <Paper>
              <Box px={2}>
                <Grid container spacing={2} alignItems="flex-end">
                  <Grid item sm={3}>
                    <DateInput
                      label="Tarixdən"
                      name="createdDateRange.from"
                      maxDate={values.createdDateRange?.to}
                      onChange={() => {
                        submitForm();
                      }}
                      setFieldValue={setFieldValue}
                    />
                  </Grid>

                  <Grid item sm={3}>
                    <DateInput
                      label="Tarixə"
                      name="createdDateRange.to"
                      minDate={values.createdDateRange?.from}
                      maxDate={todayDate}
                      onChange={() => {
                        submitForm();
                      }}
                      setFieldValue={setFieldValue}
                    />
                  </Grid>

                  <Grid item sm={1}>
                    <Center>
                      <IconButton to={Routing.generateDetailRoute(ROUTES.client, clientId)} component={Link}>
                        <CloseIcon />
                      </IconButton>
                    </Center>
                  </Grid>
                </Grid>
              </Box>
            </Paper>
          );
        }}
      </Formik>
    </Box>
  );
};
